"use strict";

require("../../util/GlobalScript.js");

module.exports = require("../buttons/Button");